import { createDefaultFieldFactory, FieldTypes } from '@sitecore-jss/sitecore-jss-react-forms';

import {
  BaseCheckbox,
  BaseCheckboxList,
  BaseDate,
  BaseDropdownList,
  BaseEmail,
  BaseListBox,
  BaseMultipleLineText,
  BaseNumber,
  BasePassword,
  BaseRadioButtonList,
  BaseSingleLineText,
  BaseTelephone,
} from '../BaseFields';
import { CustomFields } from '../Constants/CustomFields';
import {
  CheckboxWithHtml,
  DropdownListWithEvents,
  Hidden,
  MemberIdField,
  Recaptcha,
  RichTextField,
  SingleLineTextWithEvents,
  SubmitButton,
} from '../CustomFields';

const factory = createDefaultFieldFactory();

// Enhance built-in fields with proper accessibility markup (aria-describedby, aria-invalid)
// Unit tests have been added to ensure this field markup matches JSS to catch any breaking changes if JSS is updated
factory.setComponent(FieldTypes.Checkbox, BaseCheckbox);
factory.setComponent(FieldTypes.CheckboxList, BaseCheckboxList);
factory.setComponent(FieldTypes.DateField, BaseDate);
factory.setComponent(FieldTypes.DropdownList, BaseDropdownList);
factory.setComponent(FieldTypes.Email, BaseEmail);
factory.setComponent(FieldTypes.ListBox, BaseListBox);
factory.setComponent(FieldTypes.MultipleLineText, BaseMultipleLineText);
factory.setComponent(FieldTypes.NumberField, BaseNumber);
factory.setComponent(FieldTypes.Password, BasePassword);
factory.setComponent(FieldTypes.RadioButtonList, BaseRadioButtonList);
factory.setComponent(FieldTypes.SingleLineText, BaseSingleLineText);
factory.setComponent(FieldTypes.Telephone, BaseTelephone);

// Sample code to render custom field as client side component
// Any component making async calls cannot be rendered as ssr - it will give hydration error
// Add such components as No SSR using following code
/*
const RichTextFieldNoSSR = dynamic(() => import('../CustomFields/RichTextField').then((mod) => mod.RichTextField), {
  ssr: false,
});
*/

// Add custom field rendering mapping here
factory.setComponent(CustomFields.RichText, RichTextField);
factory.setComponent(CustomFields.CheckboxWithHtml, CheckboxWithHtml);
factory.setComponent(CustomFields.Hidden, Hidden);
factory.setComponent(CustomFields.Recaptcha, Recaptcha);
factory.setComponent(CustomFields.SingleLineTextWithEvents, SingleLineTextWithEvents);
factory.setComponent(CustomFields.DropdownListWithEvents, DropdownListWithEvents);
factory.setComponent(CustomFields.MemberId, MemberIdField);
factory.setComponent(CustomFields.SubmitButton, SubmitButton);

export default factory;
export const FormElementFactory = factory;
